import { formatNumberToFixedIfNotInteger } from "../number/display.ts";

export const ByteSizes = {
  TB: 1024 ** 4,
  GB: 1024 ** 3,
  MB: 1024 ** 2,
  KB: 1024,
} satisfies Record<`${string}B`, number>;

export function getReadableFileSize(fileSize: number) {
  const appropriateSize = (
    Object.keys(ByteSizes) as Array<keyof typeof ByteSizes>
  ).find((key) => {
    return fileSize >= ByteSizes[key];
  });

  if (appropriateSize) {
    const formattedSize = formatNumberToFixedIfNotInteger(
      fileSize / ByteSizes[appropriateSize],
      1
    );

    return formattedSize !== null
      ? `${formattedSize} ${appropriateSize}`
      : "n/a";
  } else {
    return `${fileSize} bytes`;
  }
}
